export default "__VITE_ASSET__f1b7fd3d__"